import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import PropTypes from 'prop-types';
import TextButton from './Buttons/TextButton';
import ImageButton from './Buttons/ImageButton';
import track from '../actions/app';
import { getCtaClickTrackingObject } from '../actions/items';
// import { CTA_CLICKED } from '../actions/types';
import './Buttons/ButtonMarkup.scss';

const getButtonMarkup = (btnProps, key) => {
	const button = btnProps.isImage ? (
		<ImageButton
			buttonProps={btnProps}
			handleCtaClicked={() => {
				track(getCtaClickTrackingObject(btnProps.btnLabel));
			}}
		/>
	) : (
		<TextButton
			buttonProps={btnProps}
			handleCtaClicked={() => {
				track(getCtaClickTrackingObject(btnProps.btnLabel));
			}}
		/>
	);
	const containerClass = `price-btn cst-btn-${btnProps.index} mb-3`;
	return (
		<div key={key} className={containerClass}>
			{button}
		</div>
	);
};

export default class ButtonList extends React.Component {
	getButtonHtml(popoverText) {
		const { labels } = this.props;
		return labels && labels.getHTML(popoverText)
			? labels.getHTML(popoverText)
			: popoverText;
	}
	getButtonLabel(btnLabel) {
		const { labels } = this.props;
		return labels && labels.get(btnLabel) ? labels.get(btnLabel) : btnLabel;
	}
	render() {
		const { items, isMobile } = this.props;
		if (items && items.length > 0) {
			return (
				<div className="vehicle-ctas">
					{items.map(item => {
						const btnProps = {
							...item,
							btnLabel: this.getButtonLabel(item.btnLabel)
						};
						const { popoverText, popoverTitle } = btnProps;
						const key = `button-${btnProps.index}`;
						const markup = getButtonMarkup(btnProps, key);
						if (popoverText) {
							const popoverPlacement = isMobile ? 'top' : 'left';
							const popoverHoverFocus = (
								<Popover
									id={`${key}-popover`}
									title={this.getButtonLabel(popoverTitle)}
								>
									{this.getButtonHtml(popoverText)}
								</Popover>
							);
							return (
								<OverlayTrigger
									key={key}
									trigger={['hover', 'focus']}
									placement={popoverPlacement}
									overlay={popoverHoverFocus}
								>
									{markup}
								</OverlayTrigger>
							);
						}
						return markup;
					})}
				</div>
			);
		}
		return null;
	}
}

ButtonList.propTypes = {
	items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func,
		getHTML: PropTypes.func
	}).isRequired,
	vehicle: PropTypes.shape({}).isRequired,
	isMobile: PropTypes.bool
};

ButtonList.defaultProps = {
	isMobile: false
};



// WEBPACK FOOTER //
// ./src/components/ButtonList.jsx